export const CONNECT_TUTORIAL_URL = 'https://youtu.be/EjKA0E3R-eM';
export const LEARN_ABOUT_BOTS_URL = 'https://youtu.be/EjKA0E3R-eM';
export const TRADINGVIEW_CHART_URL = 'https://tradingview.com/chart';
